/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function EditAction({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Phone/Phones/Content/Phone/Edit/Content/Actions/EditAction"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Save"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}